import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CourseFormDialog = ({ open, onClose, course, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '', description: '', features: [], price: 2000, duration: '9:30 - 17:00 Uhr', target_group: '', is_active: true
  });
  const [featureInput, setFeatureInput] = useState('');

  useEffect(() => {
    if (course) {
      setFormData({
        title: course.title || '', description: course.description || '', features: course.features || [],
        price: course.price || 2000, duration: course.duration || '9:30 - 17:00 Uhr',
        target_group: course.target_group || '', is_active: course.is_active !== undefined ? course.is_active : true
      });
    } else {
      setFormData({ title: '', description: '', features: [], price: 2000, duration: '9:30 - 17:00 Uhr', target_group: '', is_active: true });
    }
  }, [course]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleAddFeature = () => {
    if (featureInput.trim()) {
      setFormData(prev => ({ ...prev, features: [...prev.features, featureInput.trim()] }));
      setFeatureInput('');
    }
  };

  const handleRemoveFeature = (index) => {
    setFormData(prev => ({ ...prev, features: prev.features.filter((_, i) => i !== index) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = { ...formData, price: parseFloat(formData.price) };
      if (course) {
        await axios.put(`${BACKEND_URL}/admin/courses/${course.id}`, data);
      } else {
        await axios.post(`${BACKEND_URL}/admin/courses`, data);
      }
      onSuccess();
      onClose();
    } catch (error) {
      alert('Fehler beim Speichern des Kurses.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>{course ? 'Kurs bearbeiten' : 'Neuer Kurs'}</DialogTitle></DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="title">Kurstitel *</Label>
            <Input id="title" name="title" value={formData.title} onChange={handleChange} required placeholder="z.B. Geldgymnasium Grundlagen" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="description">Beschreibung *</Label>
            <Textarea id="description" name="description" value={formData.description} onChange={handleChange} required rows={4} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="target_group">Zielgruppe *</Label>
            <Input id="target_group" name="target_group" value={formData.target_group} onChange={handleChange} required placeholder="z.B. Einsteiger" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="price">Preis (EUR) *</Label>
              <Input id="price" name="price" type="number" step="0.01" value={formData.price} onChange={handleChange} required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="duration">Dauer</Label>
              <Input id="duration" name="duration" value={formData.duration} onChange={handleChange} />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Features</Label>
            <div className="flex gap-2">
              <Input value={featureInput} onChange={(e) => setFeatureInput(e.target.value)} placeholder="Feature hinzufügen..." onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddFeature(); } }} />
              <Button type="button" onClick={handleAddFeature}>Hinzufügen</Button>
            </div>
            <div className="flex flex-wrap gap-2 mt-2">
              {formData.features.map((feature, index) => (
                <div key={index} className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-full text-sm">
                  <span>{feature}</span>
                  <button type="button" onClick={() => handleRemoveFeature(index)} className="text-red-500 hover:text-red-700"><X className="w-3 h-3" /></button>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <input type="checkbox" id="is_active" name="is_active" checked={formData.is_active} onChange={handleChange} className="rounded" />
            <Label htmlFor="is_active">Kurs ist aktiv</Label>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Abbrechen</Button>
            <Button type="submit" disabled={loading}>{loading ? 'Speichert...' : course ? 'Aktualisieren' : 'Erstellen'}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
